export default function LoadingScreen() {
  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems:"center",
        height: '100vh',
      }}
    >
      LoadingScreen
    </div>
  );
}
